export default "__VITE_ASSET__19c7a90f__"